<div *ngIf="displayError">
  <div class="validation-msg"  style="clear:both">
    {{ errorMsg }}
  </div>
</div>

